import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoModule } from '@ngneat/transloco';
import { PasteImageZoneComponent } from './paste-image-zone.component';

@NgModule({
	// PasteImageZone: área de colar/arrastar imagem usada pelas telas de tarefa BPMN.
	declarations: [PasteImageZoneComponent],
	imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslocoModule, MatIconModule],
	// TranslocoModule é exportado aqui para que o pipe `| transloco` fique
	// disponível em todos os módulos que já importam o SharedModule, sem
	// precisar declarar o import em cada um deles.
	exports: [CommonModule, FormsModule, ReactiveFormsModule, TranslocoModule, PasteImageZoneComponent],
})
export class SharedModule {}
